import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import 'react-table/react-table.css';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ContentCreate from 'material-ui/svg-icons/content/create';
import { grey200, grey500 } from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import styled from 'styled-components';
import { localize } from 'react-localize-redux';
import { translate } from 'react-i18next';

import PageBase from './PageBase';
import { primary1Color } from '../theme';
import i18n from '../translations/i18n';

/*
  Styled components
 */
const FloatingCreateButtonStyled = styled(FloatingActionButton)`
  margin: 0 !important;
  top: auto !important;
  right: 20px !important;
  bottom: 20px !important;
  left: auto !important;
  position: fixed !important;
  background-color: ${primary1Color} !important;
  color: black !important;
`;

const ItemActionButton = styled(FloatingActionButton)`
  fill: ${grey500} !important;
  height: 30px !important;
  width: 30px !important;
`;

const ContentCreateStyled = styled(ContentCreate)`
  height: 20px !important;
  width: 20px !important;
`;

/*
  PropTypes / DefaultProps
 */
const propTypes = {
  onChange: PropTypes.func.required,
  manual: PropTypes.bool,
  columns: PropTypes.array,
  onItemEdit: PropTypes.func,
  onItemDelete: PropTypes.func,
  onItemCreate: PropTypes.func,
  title: PropTypes.any,
  rightComponent: PropTypes.any,
  t: PropTypes.func,
};

const defaultProps = {
  // Default react-table props
  className: '-striped -highlight',
  defaultPageSize: 20,
  showFilters: true,
};

class CommonTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentState: null,
    };

    this.dataChange = this.dataChange.bind(this);
    this.reloadTable = this.reloadTable.bind(this);
  }

  dataChange(state) {
    this.setState({ currentState: state });
    if (this.props.manual) {
      this.props.onChange(state);
    }
  }

  reloadTable() {
    this.props.onChange(this.state.currentState);
  }

  render() {
    const columns = this.props.columns.slice();

    if (this.props.onItemEdit || this.props.onItemDelete) {
      columns.push({
        //    header: translate('action'),
        width: 70,
        sortable: false,
        hideFilter: true,
        className: 'centerAlign',
        render: rowProps => (
          <span>
            {this.props.onItemEdit && (
              <Link className="button" onClick={() => this.props.onItemEdit(rowProps.row.id)}>
                <ItemActionButton
                  zDepth={0}
                  mini
                  backgroundColor={grey200}
                  iconStyle={{
                    fill: grey500,
                    height: 30,
                    width: 30,
                  }}
                >
                  <ContentCreateStyled />
                </ItemActionButton>
              </Link>
            )}

            {this.props.onItemDelete && (
              <Link
                className="button"
                role="button"
                onClick={() => this.props.onItemDelete(rowProps.row.id)}
              >
                <ItemActionButton zDepth={0} mini backgroundColor={grey200}>
                  <ContentCreateStyled />
                </ItemActionButton>
              </Link>
            )}
          </span>
        ),
      });
    }

    const texts = {
      previousText: this.props.t('previous'),
      nextText: this.props.t('next'),
      loadingText: this.props.t('loading'),
      noDataText: this.props.t('no_rows_found'),
      pageText: this.props.t('page'),
      ofText: this.props.t('of'),
      rowsText: this.props.t('rows'),
    };

    const tableProps = Object.assign({}, this.props, { columns }, texts);

    const title = (
      <span>
        {this.props.title}
        <IconButton onTouchTap={this.reloadTable}>
          <RefreshIndicator percentage={100} size={30} left={10} top={12} status="ready" />
        </IconButton>
      </span>
    );
    return (
      <PageBase title={title} rightComponent={this.props.rightComponent}>
        <div>
          <ReactTable {...tableProps} onChange={this.dataChange} />
          {tableProps.onItemCreate && (
            <Link onClick={() => this.props.onItemCreate()}>
              <FloatingCreateButtonStyled>
                <ContentAdd />
              </FloatingCreateButtonStyled>
            </Link>
          )}
        </div>
      </PageBase>
    );
  }
}

CommonTable.propTypes = propTypes;
CommonTable.defaultProps = defaultProps;

CommonTable.propTypes = {
  onChange: PropTypes.func.isRequired,
};

const extended = translate(['translations'], { i18n })(CommonTable);
export default localize(extended, 'locale');



// WEBPACK FOOTER //
// ./src/components/CommonTable.js